import { h } from 'preact';

const Badge = ({ badge, classes }) => {
  if (!badge.copy) return '';

  const badgeStyle = {
    color: badge.copy_color || '#ffffff',
    backgroundColor: badge.background_color || '#393D3C',
  };
  return (
    <div
      className={`${classes} body-12-med absolute z-2 flex w-fit items-center justify-center 
        rounded-[20px] px-[10px] py-[5px]`}
      style={badgeStyle}
    >
      {badge.copy}
    </div>
  );
};

export default Badge;
